import React, { useState } from 'react';
import { 
  Container as BSContainer, 
  Row as BSRow, 
  Col as BSCol, 
  Card as BSCard, 
  Table as BSTable, 
  Button as BSButton, 
  Modal as BSModal, 
  Form as BSForm,
  Badge as BSBadge,
  InputGroup as BSInputGroup
} from 'react-bootstrap';
import { 
  FaSearch, 
  FaEye, 
  FaMoneyBillWave,
  FaCheckCircle,
  FaCalendarAlt,
  FaUserCircle,
  FaTrophy,
  FaAward,
  FaMedal,
  FaUniversity,
  FaCreditCard,
  FaHashtag,
  FaCodeBranch
} from 'react-icons/fa';
import '../../../../assets/css/Ngo/controlpanelCSS/Payout.css';
import NgoLayout from '../../../../layouts/Ngo/NgoLayout';

const PayoutManagement = () => {
  const [selectedMonth, setSelectedMonth] = useState('January 2026');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedDonor, setSelectedDonor] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [transactionId, setTransactionId] = useState('');

  const donors = [
    {
      id: 1,
      name: 'Ali Khan',
      level: 'Gold',
      studentsHelped: 5,
      totalDonation: 50000,
      rewardPayout: 5000,
      rewardPercentage: 10,
      status: 'pending',
      bank: {
        accountTitle: 'Ali Khan',
        accountNumber: '1234-5678-9012-3456',
        bankName: 'HBL - Habib Bank Limited',
        branchCode: '0123',
        iban: 'PK36HABB0000001123456702',
        accountType: 'Current',
      }
    },
    {
      id: 2,
      name: 'Sara Noor',
      level: 'Silver',
      studentsHelped: 3,
      totalDonation: 30000,
      rewardPayout: 2000,
      rewardPercentage: 6.67,
      status: 'pending',
      bank: {
        accountTitle: 'Sara Noor',
        accountNumber: '9876-5432-1098-7654',
        bankName: 'Allied Bank Limited',
        branchCode: '0456',
        iban: 'PK36ABPA0010001234567890',
        accountType: 'Savings',
      }
    },
    {
      id: 3,
      name: 'Ahmed Raza',
      level: 'Bronze',
      studentsHelped: 1,
      totalDonation: 10000,
      rewardPayout: 500,
      rewardPercentage: 5,
      status: 'pending',
      bank: {
        accountTitle: 'Ahmed Raza',
        accountNumber: '1111-2222-3333-4444',
        bankName: 'Meezan Bank Limited',
        branchCode: '0789',
        iban: 'PK36MEZN0001111222233334',
        accountType: 'Current',
      }
    }
  ];

  const totalDonors = 120;
  const totalPayout = 250000;
  const pendingPayout = 30000;

  const getLevelIcon = (level) => {
    switch(level) {
      case 'Gold':   return <FaTrophy className="np-level-icon np-gold" />;
      case 'Silver': return <FaAward className="np-level-icon np-silver" />;
      case 'Bronze': return <FaMedal className="np-level-icon np-bronze" />;
      default:       return null;
    }
  };

  const getLevelBadgeVariant = (level) => {
    switch(level) {
      case 'Gold':   return 'warning';
      case 'Silver': return 'secondary';
      case 'Bronze': return 'info';
      default:       return 'primary';
    }
  };

  const handleViewDetails = (donor) => {
    setSelectedDonor(donor);
    setShowDetailsModal(true);
  };

  const handlePayNow = (donor) => {
    setSelectedDonor(donor);
    setShowPaymentModal(true);
  };

  const handleApprovePayout = () => {
    if (!paymentMethod || !transactionId) {
      alert('Please fill all payment details');
      return;
    }
    alert(`Payment of Rs. ${selectedDonor.rewardPayout.toLocaleString()} approved for ${selectedDonor.name}`);
    setShowPaymentModal(false);
    setPaymentMethod('');
    setTransactionId('');
  };

  const filteredDonors = donors.filter(donor =>
    donor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <NgoLayout>
    <div className="np-payout-management">
      <BSContainer fluid className="py-4">

        {/* Header */}
        <div className="np-page-header mb-4">
          <h1 className="np-page-title">
            <FaMoneyBillWave className="me-3" />
            NGO Dashboard | Payout Management
          </h1>
        </div>

        {/* Controls Row */}
        <BSRow className="mb-4 align-items-center">
          <BSCol md={4}>
            <div className="np-month-selector">
              <FaCalendarAlt className="np-calendar-icon" />
              <BSForm.Select 
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="np-month-dropdown"
              >
                <option>January 2026</option>
                <option>December 2025</option>
                <option>November 2025</option>
                <option>October 2025</option>
              </BSForm.Select>
            </div>
          </BSCol>
          <BSCol md={4}></BSCol>
          <BSCol md={4}>
            <BSInputGroup className="np-search-donor">
              <BSInputGroup.Text><FaSearch /></BSInputGroup.Text>
              <BSForm.Control
                placeholder="Search Donor..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </BSInputGroup>
          </BSCol>
        </BSRow>

        {/* Stats Cards */}
        <BSRow className="mb-4 np-stats-row g-3">
          <BSCol lg={4} md={4} sm={12}>
            <BSCard className="np-stats-card np-donors-card h-100">
              <BSCard.Body>
                <div className="np-stats-content">
                  <div className="np-stats-info">
                    <p className="np-stats-label">Total Donors</p>
                    <h2 className="np-stats-value">{totalDonors}</h2>
                  </div>
                  <FaUserCircle className="np-stats-icon" />
                </div>
              </BSCard.Body>
            </BSCard>
          </BSCol>
          <BSCol lg={4} md={4} sm={12}>
            <BSCard className="np-stats-card np-payout-card h-100">
              <BSCard.Body>
                <div className="np-stats-content">
                  <div className="np-stats-info">
                    <p className="np-stats-label">Total Payout</p>
                    <h2 className="np-stats-value">Rs. {totalPayout.toLocaleString()}</h2>
                  </div>
                  <FaMoneyBillWave className="np-stats-icon" />
                </div>
              </BSCard.Body>
            </BSCard>
          </BSCol>
          <BSCol lg={4} md={4} sm={12}>
            <BSCard className="np-stats-card np-pending-card h-100">
              <BSCard.Body>
                <div className="np-stats-content">
                  <div className="np-stats-info">
                    <p className="np-stats-label">Pending Payout</p>
                    <h2 className="np-stats-value">Rs. {pendingPayout.toLocaleString()}</h2>
                  </div>
                  <FaCheckCircle className="np-stats-icon" />
                </div>
              </BSCard.Body>
            </BSCard>
          </BSCol>
        </BSRow>

        {/* Donors Table — NO table-responsive wrapper, NO minWidth */}
        <BSCard className="np-table-card">
          <BSCard.Body>
            <BSTable hover className="np-donors-table">
              <thead>
                <tr>
                  <th>Donor Name</th>
                  <th>Level</th>
                  <th>Students</th>
                  <th>Total Donation</th>
                  <th>Reward</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredDonors.map((donor) => (
                  <tr key={donor.id}>
                    <td>
                      <div className="np-donor-name-cell">
                        <FaUserCircle className="np-donor-avatar" />
                        <span className="np-donor-name">{donor.name}</span>
                      </div>
                    </td>
                    <td>
                      <BSBadge bg={getLevelBadgeVariant(donor.level)} className="np-level-badge">
                        {getLevelIcon(donor.level)}
                        <span className="ms-1">{donor.level}</span>
                      </BSBadge>
                    </td>
                    <td>
                      <span className="np-students-count">{donor.studentsHelped}</span>
                    </td>
                    <td>
                      <span className="np-donation-amount">Rs. {donor.totalDonation.toLocaleString()}</span>
                    </td>
                    <td>
                      <span className="np-payout-amount">Rs. {donor.rewardPayout.toLocaleString()}</span>
                    </td>
                    <td>
                      <div className="np-action-buttons">
                        <BSButton
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleViewDetails(donor)}
                          className="np-action-btn"
                        >
                          <FaEye /> Details
                        </BSButton>
                        <BSButton
                          variant="success"
                          size="sm"
                          onClick={() => handlePayNow(donor)}
                          className="np-action-btn"
                        >
                          <FaMoneyBillWave /> Pay Now
                        </BSButton>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </BSTable>
          </BSCard.Body>
        </BSCard>

        {/* ── Details Modal ── */}
        <BSModal 
          show={showDetailsModal} 
          onHide={() => setShowDetailsModal(false)}
          centered
          className="np-details-modal"
        >
          <BSModal.Header closeButton className="np-modal-header-custom">
            <BSModal.Title>
              <FaUserCircle className="me-2" /> Donor Details
            </BSModal.Title>
          </BSModal.Header>
          <BSModal.Body>
            {selectedDonor && (
              <div className="np-donor-details">
                <div className="np-detail-row">
                  <span className="np-detail-label">Donor</span>
                  <span className="np-detail-value">{selectedDonor.name}</span>
                </div>
                <div className="np-detail-row">
                  <span className="np-detail-label">Level</span>
                  <BSBadge bg={getLevelBadgeVariant(selectedDonor.level)} className="np-level-badge">
                    {getLevelIcon(selectedDonor.level)}
                    <span className="ms-2">{selectedDonor.level}</span>
                  </BSBadge>
                </div>
                <div className="np-detail-row">
                  <span className="np-detail-label">Total Donation</span>
                  <span className="np-detail-value">Rs. {selectedDonor.totalDonation.toLocaleString()}</span>
                </div>
                <div className="np-detail-row">
                  <span className="np-detail-label">Reward %</span>
                  <span className="np-detail-value">{selectedDonor.rewardPercentage}%</span>
                </div>
                <div className="np-detail-row">
                  <span className="np-detail-label">Payout</span>
                  <span className="np-detail-value np-payout-highlight">Rs. {selectedDonor.rewardPayout.toLocaleString()}</span>
                </div>
                <div className="np-detail-row">
                  <span className="np-detail-label">Students Helped</span>
                  <span className="np-detail-value">{selectedDonor.studentsHelped}</span>
                </div>
              </div>
            )}
          </BSModal.Body>
        </BSModal>

        {/* ── Payment Modal ── */}
        <BSModal 
          show={showPaymentModal} 
          onHide={() => setShowPaymentModal(false)}
          centered
          size="lg"
          className="np-payment-modal"
        >
          <BSModal.Header closeButton className="np-modal-header-custom">
            <BSModal.Title>
              <FaMoneyBillWave className="me-2" /> Process Payment
            </BSModal.Title>
          </BSModal.Header>
          <BSModal.Body>
            {selectedDonor && (
              <>
                <div className="np-payment-summary mb-4">
                  <h5>Payment Summary</h5>
                  <div className="np-summary-details">
                    <div className="np-detail-row">
                      <span className="np-detail-label">Donor</span>
                      <span className="np-detail-value">{selectedDonor.name}</span>
                    </div>
                    <div className="np-detail-row">
                      <span className="np-detail-label">Level</span>
                      <BSBadge bg={getLevelBadgeVariant(selectedDonor.level)}>
                        {selectedDonor.level}
                      </BSBadge>
                    </div>
                    <div className="np-detail-row">
                      <span className="np-detail-label">Total Donation</span>
                      <span className="np-detail-value">Rs. {selectedDonor.totalDonation.toLocaleString()}</span>
                    </div>
                    <div className="np-detail-row np-highlight-row">
                      <span className="np-detail-label">Payout Amount</span>
                      <span className="np-detail-value np-payout-highlight">Rs. {selectedDonor.rewardPayout.toLocaleString()}</span>
                    </div>
                  </div>
                </div>

                <div className="np-bank-info-section mb-4">
                  <h5 className="np-bank-info-title">
                    <FaUniversity className="me-2" />
                    Donor's Bank Details
                  </h5>
                  <div className="np-bank-info-grid">
                    <div className="np-bank-info-item">
                      <span className="np-bank-info-icon"><FaUserCircle /></span>
                      <div>
                        <p className="np-bank-info-label">Account Title</p>
                        <p className="np-bank-info-value">{selectedDonor.bank.accountTitle}</p>
                      </div>
                    </div>
                    <div className="np-bank-info-item">
                      <span className="np-bank-info-icon"><FaUniversity /></span>
                      <div>
                        <p className="np-bank-info-label">Bank Name</p>
                        <p className="np-bank-info-value">{selectedDonor.bank.bankName}</p>
                      </div>
                    </div>
                    <div className="np-bank-info-item">
                      <span className="np-bank-info-icon"><FaHashtag /></span>
                      <div>
                        <p className="np-bank-info-label">Account Number</p>
                        <p className="np-bank-info-value np-bank-mono">{selectedDonor.bank.accountNumber}</p>
                      </div>
                    </div>
                    <div className="np-bank-info-item">
                      <span className="np-bank-info-icon"><FaCodeBranch /></span>
                      <div>
                        <p className="np-bank-info-label">Branch Code</p>
                        <p className="np-bank-info-value np-bank-mono">{selectedDonor.bank.branchCode}</p>
                      </div>
                    </div>
                    <div className="np-bank-info-item np-bank-full">
                      <span className="np-bank-info-icon"><FaCreditCard /></span>
                      <div>
                        <p className="np-bank-info-label">IBAN</p>
                        <p className="np-bank-info-value np-bank-mono">{selectedDonor.bank.iban}</p>
                      </div>
                    </div>
                    <div className="np-bank-info-item">
                      <span className="np-bank-info-icon"><FaCreditCard /></span>
                      <div>
                        <p className="np-bank-info-label">Account Type</p>
                        <p className="np-bank-info-value">{selectedDonor.bank.accountType}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <BSForm>
                  <BSRow>
                    <BSCol md={6}>
                      <BSForm.Group className="mb-3">
                        <BSForm.Label>Payment Method *</BSForm.Label>
                        <BSForm.Select 
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                          <option value="">Select Payment Method</option>
                          <option value="bank_transfer">Bank Transfer</option>
                          <option value="easypaisa">EasyPaisa</option>
                          <option value="jazzcash">JazzCash</option>
                          <option value="cheque">Cheque</option>
                        </BSForm.Select>
                      </BSForm.Group>
                    </BSCol>
                    <BSCol md={6}>
                      <BSForm.Group className="mb-3">
                        <BSForm.Label>Transaction ID / Reference *</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          placeholder="Enter transaction ID"
                          value={transactionId}
                          onChange={(e) => setTransactionId(e.target.value)}
                        />
                      </BSForm.Group>
                    </BSCol>
                  </BSRow>
                  <BSForm.Group className="mb-3">
                    <BSForm.Label>Notes (Optional)</BSForm.Label>
                    <BSForm.Control
                      as="textarea"
                      rows={2}
                      placeholder="Add any additional notes..."
                    />
                  </BSForm.Group>
                </BSForm>
              </>
            )}
          </BSModal.Body>
          <BSModal.Footer>
            <BSButton variant="secondary" onClick={() => setShowPaymentModal(false)}>
              Cancel
            </BSButton>
            <BSButton variant="success" onClick={handleApprovePayout} className="np-approve-btn">
              <FaCheckCircle className="me-2" /> Approve Payout
            </BSButton>
          </BSModal.Footer>
        </BSModal>

      </BSContainer>
    </div>
    </NgoLayout>
  );
};

export default PayoutManagement;